// import InputField from "components/Input";
import React from "react";
import HighResImg from "assets/images/highres.png";
import ZoningImg from "assets/images/zoning.png";
import StackImg from "assets/images/stack.png";
import ProductCard from "components/molecules/ProductCard";
import AlgorithmCard from "components/molecules/AlgorithmCard";
import "./index.scss";

const ProductsAndGuidesContainer = () => (
  <div className="products-page">
    <section className="header-section">
      <h1 className="title">Hi, how can we help?</h1>
      <p className="description">
        Looking for a good place to start? Watch the video tutorials and guides
        that we prepared for you.
      </p>

      {/* <InputField placeholder="search for how-tos and more..." /> */}
    </section>
    <section className="popular-products">
      <h2 className="title">Popular Products</h2>
      <ProductCard
        name="High Resolution Imagery"
        description="Ideal for monitoring in-season crop variability and performance, high
          resolution satellite imagery can detect issues that are difficult to
          spot at ground-level."
        imageSource={HighResImg}
        comingSoon
      />
      <ProductCard
        name="Zoning"
        comingSoon
        description="Know what to apply and where to apply it with rapid auto-zoning. Set up or upload your paddocks and easily export variable rate shape files compatible with most farm machinery systems including John Deere, Trimble and Case."
        imageSource={ZoningImg}
      />
      <ProductCard
        comingSoon
        name="Stack"
        description="Get a stacked view of satellite imagery over multiple years to see how your paddocks have performed long-term. By layering 5 years of imagery for one location, Stack uses NDVI maps to create a meaningful visual summary beyond what your eyes can detect."
        imageSource={StackImg}
      />
    </section>
    <div className="divider" />
    <section className="algorithms-offered">
      <h2 className="title">Calculations Offered</h2>
      <AlgorithmCard
        name="Normalized Difference Vegetation Index"
        description="Recognised across all crop and pasture industries. NDVI is the most widely used calculation, and is suitable for most situations. NDVI uses the Near InfraRed spectrum and detects plant issues before you can."
      />
      <AlgorithmCard
        name="Regional NDVI"
        description="Get a stacked view of satellite imagery over multiple years to see how your paddocks have performed long-term. By layering 5 years of imagery for one location, Stack uses NDVI maps to create a meaningful visual summary beyond what your eyes can detect."
      />
      <AlgorithmCard
        name="Normalized Difference Red Edge index"
        description="Recognised across rice, cotton, and other cereals. NDRE excels during the mid-late cropping season where plants reach full growth; NDRE continues to show variability, while NDVI saturates."
      />
      <AlgorithmCard
        name="Thermal"
        description="Thermal reflectance imagery is a relative new comer to crop and pasture management. Whilst this layer doesn't provide absolute temperature, it detects plant stresses with thermal surface reflectance. Useful in irrigation situations. "
      />
      <AlgorithmCard
        name="Plant Cell Density"
        description="Recognised across the viticulture and cotton sectors. NDRE excels during the mid-late cropping season where plants reach full growth; NDRE continues to show variability, while NDVI saturates."
      />
      <AlgorithmCard
        name="Colour"
        description="Get a stacked view of satellite imagery over multiple years to see how your paddocks have performed long-term. By layering 5 years of imagery for one location, Stack uses NDVI maps to create a meaningful visual summary beyond what your eyes can detect."
      />
    </section>
  </div>
);

export default ProductsAndGuidesContainer;
